// extracted by mini-css-extract-plugin
export var bd = "br2-K";
export var bigger = "br2-N";
export var detail = "br2-M";
export var downloadBar = "br2-J";
export var footBottom = "br2-I";
export var footBottomDesc = "br2-P";
export var footLine = "br2-E";
export var footTop = "br2-B";
export var footTopAddress = "br2-F";
export var footTopDesc = "br2-C";
export var footTopText = "br2-D";
export var footerM = "br2-A";
export var footerNavItem = "br2-H";
export var footerNavs = "br2-G";
export var ft = "br2-Q";
export var logo = "br2-L";
export var minWidthLimit = "br2-z";
export var red = "br2-O";